var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccessibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_979_16)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09091 18.1596C6.07845 18.1596 3.63636 20.6016 3.63636 23.6141C3.63636 26.6266 6.07845 29.0686 9.09091 29.0686C12.1034 29.0686 14.5455 26.6266 14.5455 23.6141C14.5455 20.6016 12.1034 18.1596 9.09091 18.1596ZM0 23.6141C0 18.5933 4.07014 14.5232 9.09091 14.5232C14.1117 14.5232 18.1818 18.5933 18.1818 23.6141C18.1818 28.6349 14.1117 32.705 9.09091 32.705C4.07014 32.705 0 28.6349 0 23.6141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9091 18.1596C27.8966 18.1596 25.4545 20.6016 25.4545 23.6141C25.4545 26.6266 27.8966 29.0686 30.9091 29.0686C33.9215 29.0686 36.3636 26.6266 36.3636 23.6141C36.3636 20.6016 33.9215 18.1596 30.9091 18.1596ZM21.8182 23.6141C21.8182 18.5933 25.8883 14.5232 30.9091 14.5232C35.9299 14.5232 40 18.5933 40 23.6141C40 28.6349 35.9299 32.705 30.9091 32.705C25.8883 32.705 21.8182 28.6349 21.8182 23.6141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5607 25.0482C17.5606 25.0483 17.5605 25.0483 17.5604 25.0484L17.1771 25.2402C16.279 25.6894 15.1868 25.3256 14.7375 24.4275C14.2883 23.5295 14.6521 22.4373 15.5502 21.988L15.9344 21.7958C18.4939 20.5163 21.5061 20.5163 24.0655 21.7958L24.4498 21.988C25.3478 22.4373 25.7117 23.5295 25.2624 24.4275C24.8132 25.3256 23.721 25.6894 22.8229 25.2402L22.4395 25.0484C22.4394 25.0483 22.4393 25.0483 22.4393 25.0482C22.4392 25.0482 22.4392 25.0482 22.4391 25.0482C20.9035 24.2807 19.0965 24.2807 17.5609 25.0482C17.5608 25.0482 17.5608 25.0482 17.5607 25.0482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0111 7.39748C32.934 7.00192 34.0029 7.42947 34.3985 8.35243L39.5589 20.3935C39.559 20.3936 39.559 20.3936 39.559 20.3937C39.8501 21.0727 40 21.8039 40 22.5423V23.6141C40 24.6183 39.186 25.4323 38.1818 25.4323C37.1777 25.4323 36.3636 24.6183 36.3636 23.6141V22.5423C36.3636 22.296 36.3136 22.0523 36.2167 21.8263L31.0561 9.78487C30.6605 8.8619 31.0881 7.79303 32.0111 7.39748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98894 7.39747C8.91191 7.79303 9.33946 8.8619 8.9439 9.78486L3.78337 21.8261L3.78333 21.8262C3.6864 22.0524 3.63636 22.2961 3.63636 22.5423V23.6141C3.63636 24.6183 2.82234 25.4323 1.81818 25.4323C0.814028 25.4323 0 24.6183 0 23.6141V22.5423C0 21.8038 0.150019 21.0726 0.441026 20.3937C0.441042 20.3937 0.441057 20.3936 0.441072 20.3936L5.60155 8.35243C5.99711 7.42947 7.06598 7.00192 7.98894 7.39747Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_979_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibility);
export default __webpack_public_path__ + "static/media/accessibility.88a464a42aaefcde96107bd0f7bcdef6.svg";
export { ForwardRef as ReactComponent };